import { errorValidation } from "./error";

import {
  validLength,
  validText,
  validNumber,
  validPhoneNumber,
  validAlphaNumeric,
  validPiva,
  validIban,
  validCodiceFiscale,
  validDate,
  validURL,
  validZipCode,
  validEmail,
  validPsw,
  validSameValue,
  validCodiceRichiesta,
  validAddress,
  validUpload,
  validMultipleNumber,
} from "./regex";

import libphonenumber from 'google-libphonenumber';

const isValidPhone = (phone) => {
  const region = "IT";
  const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
  const val = phoneUtil.parseAndKeepRawInput(phone, region);        
  return phoneUtil.isValidNumberForRegion(val, region);
}

const isValidCf = (cf) => {
return null !==
cf.match(
    /^(?:[A-Z][AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i
);
}

export const checkEmptyField = (target, value) => {
  const name = target.name;
  const type = target.type;
  const isChecked = target.checked;
  const valueLength = value.length;
  const dataValidate = target.dataset.validate;

  let isEmpty;

  switch (name) {
    case "codFiscale":
      valueLength == 16 && isValidCf(value)
       ? (isEmpty = false) : (isEmpty = true);
      break;

    case "phoneNumber":
      valueLength >= 9 && valueLength < 11 && isValidPhone(value)
        ? (isEmpty = false)
        : (isEmpty = true);
      break;

    case "otp":
      valueLength === 4 ? (isEmpty = false) : (isEmpty = true);
      break;

    case "cap":
      valueLength === 5 ? (isEmpty = false) : (isEmpty = true);
      break;

    case "reddito":
      valueLength === 4 ? (isEmpty = false) : (isEmpty = true);
      break;

    default:
      valueLength >= 3 ? (isEmpty = false) : (isEmpty = true);
      break;
  }

  switch (type) {
    case "radio":
      isChecked === true ? (isEmpty = false) : (isEmpty = true);
      break;

    default:
      break;
  }

  switch (dataValidate) {
    case "notEmpty":
      valueLength >= 2 ? (isEmpty = false) : (isEmpty = true);
      break;

    default:
      break;
  }

  return isEmpty;
};

export const checkEmptySelection = (target, value) => {
  const valueLength = value.length;
  const dataValidate = target.dataset.validate;

  let isEmpty;

  switch (dataValidate) {
    case "notEmpty":
      valueLength > 0 ? (isEmpty = false) : (isEmpty = true);
      break;

    default:
  }

  return isEmpty;
};

export const checkRadioSelection = (target) => {
  const isChecked = target.checked;
  const dataValidate = target.dataset.validate;

  let isRadioSelected;

  switch (dataValidate) {
    case "isRadioChecked":
      isChecked === true ? (isRadioSelected = true) : (isRadioSelected = false);
      break;

    default:
  }

  return isRadioSelected;
};

export const setValidationValue = (isValid, ref, value) => {
  if (isValid) {
    return (ref.current = value);
  } else {
    return (ref.current = undefined);
  }
};

export const setValidationAndErrors = (target, value, dataValidate, length) => {
  switch (dataValidate) {
    case "notEmpty":
      return errorValidation(validLength(value), target);

    case "isText":
      return errorValidation(validText(value), target);

    case "isNumber":
      return errorValidation(validNumber(value), target);

    case "isPhoneNumber":
      return errorValidation(validPhoneNumber(value), target);

    case "isAlphaNumeric":
      return errorValidation(validAlphaNumeric(value), target);

    case "isPiva":
      return errorValidation(validPiva(value), target);

    case "isIban":
      return errorValidation(validIban(value), target);

    case "isCodFiscale":
      return errorValidation(validCodiceFiscale(value), target, length);

    case "isDate":
      return errorValidation(validDate(value), target);

    case "isURL":
      return errorValidation(validURL(value), target);

    case "isZIP":
      return errorValidation(validZipCode(value), target);

    case "isEmail":
      return errorValidation(validEmail(value), target);

    case "isPsw":
      return errorValidation(validPsw(value), target);

    case "isSameValue":
      return errorValidation(validSameValue(value), target);

    case "isSelected":
      return errorValidation(validLength(value), target);

    case "isRadioChecked":
      // could be used just the value from: event.target.checked? If yes, then there is no need to ude a regex for that
      return errorValidation(target.checked, target);

    case "isChecked":
      return errorValidation(value.checked, target);

    // case "isUpload":
    //   return errorValidation(validUpload(event), target);

    case "isCodRichiesta":
      return errorValidation(validCodiceRichiesta(value), target);

    case "isIndirizzo":
      return errorValidation(validAddress(value), target);

    case "isMultipleNumber":
      return errorValidation(validMultipleNumber(value, length), target);

    case "null":
      break;

    default:
  }
};
